import { Component, computed, inject } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { ThemePreference, ThemeService } from '@shared/services/theme.service';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

interface ThemeOption {
  value: ThemePreference;
  label: string;
  icon: string;
}

@Component({
  selector: 'lib-theme-toggle',
  templateUrl: 'theme-toggle.component.html',
  styleUrls: ['theme-toggle.component.scss'],
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, SvgIconComponent],
})
export class ThemeToggleComponent {
  private readonly themeService = inject(ThemeService);

  public readonly options: ThemeOption[] = [
    { value: 'light', label: 'Light', icon: 'sun' },
    { value: 'dark', label: 'Dark', icon: 'moon' },
    { value: 'system', label: 'Match device', icon: 'monitor' },
  ];

  public readonly preference = this.themeService.preference;

  public readonly selectedOption = computed(() => this.options.find(option => option.value === this.preference()) ?? this.options[0]);

  public select(preference: ThemePreference): void {
    this.themeService.setPreference(preference);
  }
}
